import Vue from 'vue';
import { MutationTree } from 'vuex';
import { ApplicationFormTemplateState, ApplicationFormTemplate } from './types';
import * as types from './mutation-types';
import { ErrorDetail } from '../../types';

// エラーをクリアする
const resetErrors = (state: ApplicationFormTemplateState): void => {
    const searchState = state.search;
    searchState.error = false;
    searchState.errorCode = undefined;
    searchState.errorMsg = undefined;

    const showState = state.show;
    showState.error = false;
    showState.errorCode = undefined;
    showState.errorMsg = undefined;

    const countState = state.count;
    countState.error = false;
    countState.errorCode = undefined;
    countState.errorMsg = undefined;
};

export const mutations: MutationTree<ApplicationFormTemplateState> = {
    // 申請テンプレート一覧系
    [types.SEARCH_START](state) {
        resetErrors(state);
        const searchState = state.search;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](
        state,
        payload: { count: number; templates: Array<ApplicationFormTemplate>; simple_application_button_hidden: boolean }
    ) {
        state.templateCount = payload.count;
        state.templates = payload.templates;
        state.simpleApplicationButtonHidden = payload.simple_application_button_hidden;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const searchState = state.search;
        searchState.errorCode = payload.code;
        searchState.errorMsg = payload.message;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // 申請テンプレート詳細情報参照系
    [types.SHOW_START](state) {
        resetErrors(state);
        state.templateDetails = {};
        const showState = state.show;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SHOW_RECEIVE_BASE](state, payload) {
        Vue.set(state.templateDetails, 'base', payload);
    },

    [types.SHOW_RECEIVE_CUSTOMIZE_FIELD](state, payload) {
        Vue.set(state.templateDetails, 'customize_fields', payload);
    },

    [types.SHOW_RECEIVE_BUSINESS](state, payload) {
        Vue.set(state.templateDetails, 'businesses', payload);
    },

    [types.SHOW_RECEIVE_WORKER](state, payload) {
        Vue.set(state.templateDetails, 'workers', payload);
    },

    [types.SHOW_RECEIVE_WORKFLOW](state, payload) {
        Vue.set(state.templateDetails, 'workflow', payload);
    },

    [types.SHOW_SUCCESS](state) {
        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // 申請テンプレート件数取得系
    [types.COUNT_START](state) {
        resetErrors(state);
        const countState = state.count;
        countState.isProcessing = true;
        countState.isFetchSuccess = false;
    },

    [types.COUNT_SUCCESS](state, payload: { count: number }) {
        state.templateCount = payload.count;

        const countState = state.count;
        countState.isProcessing = false;
        countState.isFetchSuccess = true;
    },

    [types.COUNT_FAILURE](state, payload: { code: string; message: string }) {
        const countState = state.count;
        countState.errorCode = payload.code;
        countState.errorMsg = payload.message;
        countState.error = true;
        countState.isProcessing = false;
        countState.isFetchSuccess = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;

        const countState = state.count;
        countState.isProcessing = false;
        countState.isFetchSuccess = false;
    },

    [types.CLEAR_ON_ROUTE](state) {
        resetErrors(state);
        state.templates = undefined;
        state.templateDetails = {};
        // templateCount はナビバーで使っているので消さない
    },
};
